import { render, staticRenderFns } from "./ComplianceMessagingReport.vue?vue&type=template&id=0c8a13b4&scoped=true"
import script from "./ComplianceMessagingReport.vue?vue&type=script&lang=js"
export * from "./ComplianceMessagingReport.vue?vue&type=script&lang=js"
import style0 from "./ComplianceMessagingReport.vue?vue&type=style&index=0&id=0c8a13b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8a13b4",
  null
  
)

export default component.exports